import { __ } from './utils';
import { Selector, SelectorOptionsList } from './shared/index';

export default ({ value = null, options = [], onChange = null }) => {
	/*
	const _capacities = options.map((cap, id) => ({ 
		id: id, 
		title: cap.title,
		icon: cap.icon,
		info: cap.price,
	}));
	*/
	return (
		<Selector id="box-capacity-selector" title={ __('Nombre de bouteilles')  }>
			<SelectorOptionsList value={ value } options={ options } onChange={ onChange } />
		</Selector>
	)
};